// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const TeamChatUserStatus = {
    GetUserStatusForTeamChat(fn, req) {
        return fn(`/team-chat/v1/user-status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateUserStatusForTeamChat(fn, req) {
        return fn(`/team-chat/v1/user-status`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Triggering the end point would run a script
     */
    RefreshAllUserAndLocationStatuses(fn, req) {
        return fn(`/team-chat/v1/user-status/refresh-all`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteUserStatusForTeamChat(fn, req) {
        return fn(`/team-chat/v1/user-status?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    UpdateUserStatusForConversation(fn, req) {
        return fn(`/team-chat/v1/user-status/conversation`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    TeamChatAuthToken(fn, req) {
        return fn(`/team-chat/v1/token?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    TeamChatListAssociatedLocations(fn, req) {
        return fn(`/team-chat/v1/locations/children`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateUserPresenceForTeamChat(fn, req) {
        return fn(`/team-chat/v1/user-presence`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetUserMessageDetails(fn, req) {
        return fn(`/team-chat/v1/user-message-details?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
